module.exports = __webpack_public_path__ + "static/media/history_19.baf047cc.jpg";